<template id="clientsIncludes">
<section class="ourClientsIncludes">
  <div class="container" :l="clients.length">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="headingBar">
          <h3>{{res.clients}}</h3>
          <span><img alt="#" src="images/icon-headingbar.png"></span> </div>
      </div>
      <client v-for="client in clients" :client="client">
      <!--div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items01.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Adult shops</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items02.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Non-profit organizations/<br>
              NGOs/<br>
              charity group</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items03.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Hospital/clinic/<br>
              medical center</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items04.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Pharmacy/<br>
              drug stores/dispensary</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items05.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Academic institutes</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items06.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Campus <br>
              co-op shops</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items07.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Groceries stores</a></div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-6">
        <div class="brandItems">
          <div class="clientIcons"><img src="images/brand-items08.png" alt="#"></div>
          <div class="clientInfo">
            <div class="clientInfoText"><a>Online shops<br>
              (must have valid business<br>
              registration document)</a></div>
          </div>
        </div>
      </div-->
    </div>
  </div>
  </div>
</section>
</template>

<script>

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

import client from './Client.vue'

var data = {
  clients:[]
};
export default {
  name: 'clientsIncludes',
  props:['name', 'clients', 'res'],
  data () {
    return data
  },
  components: {
    client
  },
  created: function() {
    if (this.clients == null) {
      Vue.http.get('json/clients.json').then(response => {
        data.clients = JSON.parse(response.bodyText);
      }, response => {
      });
    } else {
      data.clients = this.clients;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientsIncludes.vue